export function StatusBadge({ status, t }: { status: string; t: (key: string, fallback?: string) => string }) {
  const styles: Record<string, string> = {
    completed: 'bg-green-50 text-green-700',
    complete: 'bg-green-50 text-green-700',
    finalized: 'bg-green-50 text-green-700',
    in_progress: 'bg-amber-50 text-amber-700',
    draft: 'bg-gray-100 text-gray-600',
    clinician_draft: 'bg-blue-50 text-blue-700',
    front_desk_review: 'bg-amber-50 text-amber-700',
  };
  const label: Record<string, string> = {
    completed: 'Complete',
    complete: 'Complete',
    finalized: 'Finalized',
    in_progress: 'In progress',
    draft: 'Draft',
    clinician_draft: 'Pending review',
    front_desk_review: 'Front desk',
  };
  return (
    <span className={`inline-block px-2.5 py-0.5 rounded-full text-[11px] font-medium ${styles[status] || 'bg-gray-100 text-gray-600'}`}>
      {t(`statusBadges.${status}`, label[status] || status)}
    </span>
  );
}
